import React, { CSSProperties, FC } from 'react';
import { Img } from 'react-image';
import Loading from '../Loading';

const Image: FC<Props> = ({
  alt,
  srcImg,
  style,
  onClick,
  loader,  // 图片加载完成前的展示
}) => (
  <Img alt={alt} onClick={onClick} src={[srcImg]} key={srcImg} style={style} loading="lazy" loader={loader || <Loading loadingType="spokes" style={{ position: undefined }} />} />
);

export interface Props {
  alt?: string;
  srcImg: string;
  style?: CSSProperties;
  onClick?: any;
  loader?: any;
}

export default Image;
